/* eslint-disable unused-imports/no-unused-vars */
import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { Observable, map, mergeMap, of, withLatestFrom } from 'rxjs';

import { AuthFacade } from '~backoffice/app/~store/facades/auth.facade';
import { ROUTES } from '../constants/routes.constants';

export const AUTHENTICATED_GUARD = (
  route: ActivatedRouteSnapshot,
  next: RouterStateSnapshot
): Observable<UrlTree | boolean> => {
  const requestedUrl = next.url;
  const authFacade = inject(AuthFacade);
  const router = inject(Router);

  return authFacade.accessToken$.pipe(
    withLatestFrom(authFacade.currentUser$),
    mergeMap(([accessToken, currentUser]) => {
      return of(accessToken);
    }),
    map(accessToken => {
      if (!accessToken) {
        authFacade.setLastRequestedRoute(requestedUrl);
        return router.createUrlTree([ROUTES.login]);
      }
      return true;
    })
  );
};
